import React, { useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import { ToolOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { hasHeadquartersAccess } from '../../../utils/auth';

const OrderCloseLayout: React.FC = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const menuItems = useMemo(() => [
        {
            key: 'order-close',
            label: t('orderClose.title'),
            icon: <ToolOutlined />,
            display: hasHeadquartersAccess(),
            onClick: () => navigate('/order-close')
        }
    ], [t, i18n.language, i18n.resolvedLanguage, navigate]);

    return (
        <MainLayout
            activeFirstMenu="order-close"
            secondMenu={menuItems}
        >
            <Outlet />
        </MainLayout>
    );
};

export default OrderCloseLayout;
